// Payment method data model for the SaaS billing prototype.
// See plans/saas-billing/01-stripe-billing-foundation.md for canonical types.

export type CardBrand =
  | 'visa' | 'mastercard' | 'amex' | 'discover' | 'verve' | 'other';

export interface PaymentMethod {
  id: string;
  type: 'card' | 'bank';
  brand: CardBrand | null;             // Null for bank methods
  last4: string;
  expMonth: number | null;
  expYear: number | null;
  isDefault: boolean;
}
